export default "__VITE_ASSET__f54717bd__"